export class PlaneraKartaIcons {

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Avlagg = {
        id: "avlagg",
        height: "25px",
        width: "25px",
        iconUrlPath: "/core/assets/img/karta/avlagg.png"
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Larmpunkt = {
        id: "larmpunkt",
        height: "25px",
        width: "25px",
        iconUrlPath: "/core/assets/img/karta/larm.png"
    };

    // eslint-disable-next-line sonarjs/public-static-readonly
    static Kojplats = {
        id: "kojplats",
        height: "25px",
        width: "25px",
        iconUrlPath: "/core/assets/img/karta/kojplats.png"
    };
}
